export default __webpack_public_path__ + "static/media/plus.abd4712a.svg";